import { render, staticRenderFns } from "./GoCatDetails.vue?vue&type=template&id=5065d98d&"
import script from "./GoCatDetails.vue?vue&type=script&lang=js&"
export * from "./GoCatDetails.vue?vue&type=script&lang=js&"
import style0 from "./GoCatDetails.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports